import { render, staticRenderFns } from "./StrikerComponent.vue?vue&type=template&id=36dcbe22&"
import script from "./StrikerComponent.vue?vue&type=script&lang=js&"
export * from "./StrikerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports